import { useQuery } from '@apollo/client';
import { Skeleton } from '@mui/material';
import type React from 'react';
import showMyCollections from 'src/api/collection/showMyCollections';
import usePlaylistItemStyles from 'src/HomePage/DrawerAndPushedContents/RightSideDrawer/playlistItemStyles';
import viewStateVar from 'src/store/viewState';
import PlaylistItem from './PlaylistItem';

interface CollectionNode {
  id: string;
  name: string;
  items?: {
    edges: Array<{
      node: {
        contentObject?: {
          id: string;
        };
      };
    }>;
  };
}

interface CollectionEdge {
  node: CollectionNode;
}

interface AllCollectionsData {
  allCollections?: {
    edges: CollectionEdge[];
  };
}

const MyCollectionDetails: React.FC = () => {
  const sharedClasses = usePlaylistItemStyles();

  const playlistClickHandler = (selected: string, selectedName: string): void => {
    viewStateVar({
      ...viewStateVar(),
      openNewCollection: false,
      openEditCollection: true,
      openMyCollection: false,
      selectedCollectionId: selected,
      selectedCollectionName: selectedName,
    });
  };

  const { data, loading } = useQuery<AllCollectionsData>(showMyCollections, {
    fetchPolicy: 'network-only',
  });

  if (!data || loading) {
    return (
      <div style={{ width: '100%' }}>
        {[0, 1, 2].map((i) => (
          <div key={i} className={sharedClasses.skeletonRow}>
            <Skeleton variant="rectangular" width={32} height={22} animation="wave" sx={{ borderRadius: 0.5 }} />
            <Skeleton variant="text" width={`${50 + (i % 3) * 15}%`} height={16} animation="wave" sx={{ flex: 1 }} />
            <Skeleton variant="circular" width={20} height={20} animation="wave" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={sharedClasses.thinScrollbar} style={{ width: '100%', cursor: 'pointer', overflow: 'auto' }}>
      {data?.allCollections?.edges.map((sss) => (
        <PlaylistItem key={`cyp-my-collection-${sss.node.id}`} playlist={sss.node} onClick={playlistClickHandler} />
      ))}
    </div>
  );
};

export default MyCollectionDetails;
